/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Report_ButtonInputs */

const en_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report`)
};

const fr_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport`)
};

const de_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht`)
};

const it_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporto`)
};

const ru_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчет`)
};

const es_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe`)
};

const zh_cn2_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报告`)
};

const ja_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報告`)
};

const hi_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिवेदन`)
};

const pt_pt2_style_guide_report_button = /** @type {(inputs: Style_Guide_Report_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório`)
};

/**
* | output |
* | --- |
* | "Report" |
*
* @param {Style_Guide_Report_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_report_button = /** @type {((inputs?: Style_Guide_Report_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Report_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_report_button(inputs)
	if (locale === "de") return de_style_guide_report_button(inputs)
	if (locale === "it") return it_style_guide_report_button(inputs)
	if (locale === "ru") return ru_style_guide_report_button(inputs)
	if (locale === "es") return es_style_guide_report_button(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_report_button(inputs)
	if (locale === "ja") return ja_style_guide_report_button(inputs)
	if (locale === "hi") return hi_style_guide_report_button(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_report_button(inputs)
	return en_style_guide_report_button(inputs)
});